import React from 'react';

import { getCurrentItem } from '../../../store/selectors/getCurrentItem';
import { useStudentSelector } from '../../../store/selectors/useStudentSelector';
import { TestMe } from './TestMe';
import { isQuiz } from '@ael/core-api';
import { FroalaEditorsSettings } from 'src/config/configs';

export const TestMeWrapper = ({ froalaEditorsSettings }: { froalaEditorsSettings: FroalaEditorsSettings }) => {
  const currentItem = useStudentSelector(getCurrentItem);
  return currentItem && isQuiz(currentItem) ? <TestMe currentItem={currentItem} key={currentItem.id} froalaEditorsSettings={froalaEditorsSettings} /> : null;
};
